import Axios from 'axios';

Axios.defaults.baseURL = 'https://api.akshatjewellers.com/api';

export const axiosInstance = Axios.create({});
